import { FC, ReactElement } from 'react';
import { world } from '../../languages';

type CountrySpecificProps = {
    allowed?: string | string[];
    forbidden?: string | string[];
    children: ReactElement | string | null;
};

const CountrySpecific: FC<CountrySpecificProps> = ({ children, allowed, forbidden }) => {
    let showBlock = false;

    if (forbidden) {
        if (typeof forbidden === 'string' && forbidden === world) {
            return null;
        }
        if (Array.isArray(forbidden) && forbidden.includes(world)) {
            return null;
        }
    }

    if (allowed) {
        if (typeof allowed === 'string' && allowed === world) {
            showBlock = true;
        }
        if (Array.isArray(allowed) && allowed.includes(world)) {
            showBlock = true;
        }
    } else {
        showBlock = true;
    }

    if (!showBlock) {
        return null;
    }

    return <>{children}</>;
};

export default CountrySpecific;
